export enum ProjectOAuth2KakaoPrompt {
    None = 'none',
    Login = 'login',
    Create = 'create',
    SelectAccount = 'select_account',
}
